import { Component, HostListener } from '@angular/core';
import { TFMService } from 'app/mock-api/tfm.service';
import { trigger, state, style, transition, animate} from '@angular/animations';
import { Router, RouterLink } from '@angular/router';
import { NgClass, NgIf, NgStyle } from '@angular/common';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';

@Component({
    selector: 'app-slide-banner-type01',
    standalone: true,
    imports: [NgIf, RouterLink, NgStyle,NgClass],
    templateUrl: './slide-banner-type01.component.html',
    styleUrl: './slide-banner-type01.component.scss',
    animations: [],
})
export class SlideBannerType01Component {
    constructor(private router: Router, private _tfmService: TFMService) {}

    public view: any = {
        // currentImage:
        //     'assets/xltravel/popup_banner/8LACK_FRIDAY_CONCEPT_2024-03.png',
        currentImage:
            'assets/xltravel/popup_banner/8LACK_FRIDAY_CONCEPT_2024-04.png?v=1',
    };

    isVisible: boolean = true;

    ngOnInit(): void {
        this._tfmService.getSite().then((res) => {
            this.view.site = res;
        });
    }

    onViewMore(): void {
        // this.router.navigate(['packages/black-friday-specials']);
        console.log('View More button clicked');
    }

    closeBanner(): void {
        this.isVisible = false;
    }
}
